export const InputHelper = {
  validateFloatNumberInput: (e, onChange) => {
    const input = e.target.value.trim();
    if (!input) {
      onChange("");
      return;
    }
    const validPattern = /^\d*\.?\d{0,3}$/;
    if (!validPattern.test(input)) {
      return;
    }
    onChange(input.startsWith(".") ? `0${input}` : input);
  },
};
